import React from 'react'
import classNames from 'classnames'
import { WemoloTypography } from '../../../components/Wemolo'
import { DETECTION_EXPLORER_TEXT } from '../config'
import styles from './DetectionsEmptyState.module.css'

type Props = {
    /** Lets a view add layout hooks it needs (e.g. spanning a grid/table row). */
    className?: string
}

// Single source of truth for the "no detections" state shared by the table, gallery, and
// group-by-plate views. Each view wraps it in its own required container (a `td colSpan`, a
// grid-spanning cell, …) but the message and styling stay uniform here.
export const DetectionsEmptyState: React.FC<Props> = ({ className }) => (
    <div className={classNames(styles.root, className)}>
        <WemoloTypography variant="body-small" tag="span">
            {DETECTION_EXPLORER_TEXT.emptyState}
        </WemoloTypography>
    </div>
)
